<template>
  <div style="width:100%;">
    <Loading :value="loading"></Loading>
    <v-layout wrap>
      <!-- ligne1 -->
      <v-flex xs12>
        <v-layout row>
          <v-flex xs4 class="mb-2 mr-1">
            <v-card color="cyan darken-2" class="white--text elevation-5">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs5>
                    <div>
                      <div class="headline">{{totalReserve}}</div>
                      <div>Total réserve(s)</div>
                    </div>
                  </v-flex>
                  <v-flex xs7>
                    <div>Taux reprise (%)</div>
                    <div class="display-3">{{tauxReprise}}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs4 class="mb-2 mr-1">
            <v-card color="orange darken-2" class="white--text elevation-5">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">{{reserveValid}}</div>
                      <div>Réserve(s) validée(s)</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <div>Réserves (en cours)</div>
                    <div class="display-3">{{reserveEnCours}}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs4 class="mb-2">
            <v-card color="red darken-2" class="white--text elevation-5">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">{{tacheTermine}}</div>
                      <div>Travaux réserve terminés</div>
                    </div>
                    <div>
                      <div class="headline">{{nbTrx}}</div>
                      <div>Total travaux</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <div>Travaux à refaire</div>
                    <div class="display-3">{{tacheRefaire}}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
       <!-- fin ligne1 -->

      <!-- ligne2 -->
      <v-flex xs12>

        <v-layout row>
         <v-flex xs6 class="text-xs-center pr-2 ml-2">
            <v-card class="elevation-5 pl-2 pt-2">
              <h4>
                Rapport non effectués
                <v-chip outline color="red">{{listeRptNon.length}}</v-chip>
              </h4>
              <v-divider class="mb-1"></v-divider>
              <el-table :data="listeRptNon" height="325" style="width: 100%">
                <el-table-column prop="dateRpt" label="Date" width="180"></el-table-column>
                <el-table-column prop="travaux" label="Travaux"></el-table-column>
                <el-table-column label="ACTION" align="center"  fixed="right">
                  <template slot-scope="scope">
                      <v-tooltip bottom>
                          <v-btn
                          @click="rapportJour(scope.row)"
                          slot="activator"
                          color="orange"
                          fab
                          dark
                          small
                          >
                          <v-icon>note_add</v-icon>
                          </v-btn>Effectuer rapport journalier
                      </v-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </v-card>
          </v-flex>

          <v-flex xs6>
            <div class="elevation-3 pt-2" id="statusRapportID" style="width: auto; height:100%"></div>
          </v-flex>
        </v-layout>
      </v-flex>
       <!-- ligne2 -->

    </v-layout>

    <!-- RAPPORT JOURNALIERS-->
      <RapportJournalier :dateRpt="dateRapport"  :detailTrx= detailTravaux    :show= showRapport     @close="showRapport = false" @reloadListeTrx="loadStatRapport();$emit('reloadListeTravaux'); " > </RapportJournalier>
    <!-- RAPPORT JOURNALIERS -->
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";

import Loading from "@/components/Loading";
import RapportJournalier from '@/components/boardChantier/RapportJournalier';

export default {
  components: { Loading,RapportJournalier },
  name: "WidgetTravaux",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number,
      default: 0
    },
    listeTrx: {
      type: Array
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      statusRapport: [],
      listeRptNon: [],
      totalReserve: 0,
      reserveEnCours: 0,
      reserveValid: 0,
      tacheRefaire: 0,
      tacheTermine: 0,
      tauxReprise: 0,
      nbTrx: 0,
      showRapport:false,
      detailTravaux:{},
      dateRapport: null
    };
  },

  watch: {},

  methods: {
    //statistique rapport
    statStatutRapport() {
      let optionRapport = {
        title: {
          text: "ETAT DES RAPPORTS JOURNALIERS",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [
          {
            name: "",
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],

            label: {
              normal: {
                position: "inner"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
              //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
            ]
          },
          {
            name: "",
            type: "pie",
            radius: ["40%", "55%"],
            label: {
              normal: {
                formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                borderWidth: 1,
                borderRadius: 4,

                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 16,
                    align: "center"
                  },

                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 20
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 2],
                    borderRadius: 2
                  }
                }
              }
            },
            data: [
              {
                value: this.statusRapport.nbRptNonEffec,
                name: "Non effectués"
              },
              {
                value: this.statusRapport.nbRptEffec,
                name: "Effectués"
              }
            ]
          }
        ]
      };
      let geneChartRapport = echarts.init(
        document.getElementById("statusRapportID")
      );
      geneChartRapport.setOption(optionRapport);
    },

    loadStatRapport() {
      let url = this.domaine + "journal/stat/travaux";
      let data = new FormData();
      data.append("listeTrx", JSON.stringify(this.listeTrx));
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          this.statusRapport.nbRptEffec = response.body.nbRptEffec;
          this.statusRapport.nbRptNonEffec = response.body.nbRptNonEffec;
          //this.statusRapport.push(response.body.statRapport);
          this.listeRptNon = response.body.listeTrxNonEffec;
          this.statStatutRapport();
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors de dashboard travaux");
        }
      );
    },
    loadStatReserve() {
      let url = this.domaine + "reserve/stat/travaux";
      let data = new FormData();
      data.append("listeTrx", JSON.stringify(this.listeTrx));
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          this.totalReserve = response.body.totalReserve;
          this.reserveEnCours = response.body.reserveEnCours;
          this.reserveValid = response.body.reserveValid;
          this.tacheRefaire = response.body.tacheRefaire;
          this.tacheTermine = response.body.tacheTermine;
          this.tauxReprise = response.body.tauxReprise;
          this.nbTrx = response.body.nbTrx;
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors chargement reserves dashboard");
        }
      );
    },
    rapportJour(item){
      let url = this.domaine + 'travaux/'+item.idTrx
              this.$http.get(url).then(response => {
                  this.detailTravaux = response.body.travaux;
                  this.dateRapport = new Date(item.dateRptFormat)
                  this.showRapport = true
                  this.loading = false;
              },
              error =>{
                  this.loading = false;
                  this.$message.error('Echec lors du chargement formulaire en cours')
              })
    }
  },
  watch: {
    listeTrx: function(newValue, oldValue) {
      this.statStatutRapport();
      this.loadStatRapport();
      this.loadStatReserve();
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/boardTravaux/widgetTravaux.vue